import { CampaignStatus, CampaignType } from './campaign';
import { TargetPlatformType } from './media-platform-account';

export interface CampaignFilters extends CampaignFilterPayload {
  title: string, // Filtered for on the FE
}

export enum SortType {
  NEWEST = 'NEWEST',
  OLDEST = 'OLDEST'
}

// API call payload
export interface CampaignFilterPayload {
  status: CampaignStatus,
  type: CampaignType,
  sortType: SortType,
  from: string, // ISO date-time string
  to: string, // ISO date-time string
  // listings
  gbpAccountIds: string[],
  platform: TargetPlatformType[],
}